import React from 'react';
import { Star, Quote } from 'lucide-react';
const TESTIMONIALS = [{
  name: 'María Fernanda López',
  age: '42 años',
  location: 'Ciudad de México, México',
  text: 'Después de 15 años dando economía, este material cambió completamente mi forma de enseñar. Mis alumnos ahora participan y entienden. Ya no improviso más.'
}, {
  name: 'Roberto Carlos Martínez',
  age: '38 años',
  location: 'Bogotá, Colombia',
  text: 'Lo que más valoro es el tiempo que me ahorra. Llego a casa y puedo estar con mi familia en vez de planificar hasta las 11 de la noche. Las clases están impecables.'
}, {
  name: 'Carmen Beatriz Rodríguez',
  age: '51 años',
  location: 'Madrid, España',
  text: 'Pensé que ya lo había visto todo en educación. Pero este pack me devolvió las ganas de enseñar. Los ejemplos son perfectos para conectar con los estudiantes.'
}, {
  name: 'Gustavo Hernán Pérez',
  age: '45 años',
  location: 'Santiago, Chile',
  text: 'Soy docente hace 20 años y siempre me costó explicar macro. Con este material, hasta los conceptos más complejos se vuelven claros. Mis alumnos aprueban más y mejor.'
}, {
  name: 'Laura Cecilia Gómez',
  age: '39 años',
  location: 'Lima, Perú',
  text: 'Compré este pack con dudas, pero fue la mejor inversión del año. Ahora entro al aula segura, con todo preparado. Mis clases tienen otra calidad.'
}];
export function TestimonialSection() {
  return <section className="py-20 bg-gray-50" data-id="element-145">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-146">
        <div className="text-center mb-16" data-id="element-147">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-148">
            Lo que dicen otros docentes
          </h2>
          <div className="w-24 h-1 bg-blue-600 mx-auto rounded-full" data-id="element-149"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-150">
          {TESTIMONIALS.map((testimonial, index) => <div key={index} className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100 hover:shadow-xl transition-shadow duration-300 relative" data-id="element-151">
              <Quote className="absolute top-6 right-6 text-blue-100 w-10 h-10" data-id="element-152" />

              <div className="flex gap-1 mb-4" data-id="element-153">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 text-yellow-400 fill-current" data-id="element-154" />)}
              </div>

              <p className="text-gray-700 italic mb-6 leading-relaxed" data-id="element-155">
                "{testimonial.text}"
              </p>

              <div className="flex items-center mt-auto border-t border-gray-100 pt-4" data-id="element-156">
                <div className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center text-white font-bold text-lg mr-3" data-id="element-157">
                  {testimonial.name.charAt(0)}
                </div>
                <div data-id="element-158">
                  <p className="font-bold text-gray-900 text-sm" data-id="element-159">
                    {testimonial.name}
                  </p>
                  <p className="text-xs text-gray-500" data-id="element-160">
                    {testimonial.age} • {testimonial.location}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}